import {
  ACCESS_TOKEN_STORAGE_KEY,
  ACCOUNT_ID_STORAGE_KEY,
  isAuthenticated,
  accessToken,
  currentAccountId as accountId,
} from './lib/authentication'

import { BroadcastMessageType, broadcastMessage } from './lib/broadcastMessage'
import { VERSION } from './lib/version'
import workerUrl from './worker?worker&url' // eslint-disable-line import/no-unresolved

const workerType = window.SharedWorker ? 'SharedWorker' : 'Worker'

const workerOpts = {
  name: `Harvest Platform ${workerType} v${VERSION}-${
    import.meta.env.VITE_BUILD_COMMIT_URL || 'dev'
  }`,
  type: import.meta.env.PROD ? 'classic' : 'module',
}

// TODO how often should we reload?
const RELOAD_MS = 24 * 60 * 60 * 1000

const worker = window.SharedWorker
  ? new SharedWorker(workerUrl, workerOpts).port
  : new Worker(workerUrl, workerOpts)

worker.onmessage = ({ data }) => {
  if (data.type === BroadcastMessageType.TimerStarted) {
    broadcastMessage({
      type: BroadcastMessageType.TimerStarted,
      value: {
        external_reference: {
          id: data.value.external_reference?.id,
          group_id: data.value.external_reference?.group_id,
        },
      },
      crossOrigin: true,
    })
  } else if (data.type === BroadcastMessageType.TimerStopped) {
    broadcastMessage({
      type: BroadcastMessageType.TimerStopped,
      crossOrigin: true,
    })
  }
}

// Inform the worker before disconnecting
window.onbeforeunload = () => {
  worker.postMessage({ type: 'disconnect' })
}

// Currently, the online event doesn't work in a SharedWorker
window.ononline = () => {
  worker.postMessage({ type: 'online' })
}

// Reload every once in a while to get the latest worker
setTimeout(
  () => {
    window.location.reload()
  },
  RELOAD_MS + Math.round((Math.random() * RELOAD_MS) / 10)
)

// Reload when accountId or accessToken change to
// reinitialize worker connection
window.addEventListener('storage', (evt) => {
  if (
    evt.key === ACCESS_TOKEN_STORAGE_KEY ||
    evt.key === ACCOUNT_ID_STORAGE_KEY
  ) {
    window.location.reload()
  }
})

if (isAuthenticated()) {
  worker.postMessage({ type: 'init', accessToken, accountId })
}
